module.exports = __webpack_public_path__ + "static/media/21.f9cf254f.jpg";